const post = {
    "slug": "7-anomaliy-v-bankovskoy-vypiske-yuridicheskogo-lica",
    "title": "7 аномалий в банковской выписке юридического лица, которые стоит проверить в первую очередь",
    "description": "Разбираем 7 аномалий в банковской выписке юридического лица при банкротстве: платежи техническим компаниям, резкий рост зарплат, погашение займов физлицам, подотчетные суммы, личные расходы, встречные расчеты и концентрация платежей на рискованных контрагентах.",
    "listDescription": "Практический разбор сигналов в выписке юридического лица, которые стоит проверить первыми при анализе должника в банкротстве.",
    "datePublished": "2026-05-04",
    "dateModified": "2026-05-04",
    "datePublishedLabel": "4 мая 2026",
    "readingTime": "13 минут",
    "category": "Банкротство",
    "articleSection": "Анализ выписок",
    "tags": [
        "Анализ выписок",
        "Банкротство",
        "Юридические лица",
        "Подозрительные операции",
        "Контрагенты"
    ],
    "keywords": "аномалии в банковской выписке юридического лица, анализ выписки юридического лица, банковская выписка должника юридического лица, подозрительные операции в выписке юрлица, анализ выписки должника при банкротстве, вывод активов юридического лица, оспаривание сделок юридического лица, предбанкротный период юридического лица, платежи техническим компаниям, анализ контрагентов в банкротстве",
    "heroImage": {
        "src": "/assets/blog/10-minutes/riski-po-kontragentam.webp",
        "alt": "7 аномалий в банковской выписке юридического лица для проверки при банкротстве",
        "caption": "Анализ выписки юридического лица помогает выделить контрагентов, операции и периоды, которые требуют первоочередной проверки."
    },
    "content": [
        {
            "type": "lead",
            "text": "Банковские выписки должника-организации хорошо показывают аномальные операции. Хотя сама по себе не каждая аномалия является сделкой под оспаривание, банковские выписки показывают, на что обратить особое внимание: контрагенты, через которых оптимизировали налоги; юридически не связанные лица, с которыми существует экономическая взаимозависимость; сделки с предпочтением, – эти и другие операции частые находки в банковских выписках предприятия-банкрота."
        },
        {
            "type": "paragraph",
            "text": "По движению денег можно увидеть платежи рискованным контрагентам, резкий рост выплат связанным лицам, нетипичные расходы, регулярные подотчетные суммы, встречные расчеты и другие сигналы, которые могут указывать на вывод активов или искажение реальной экономической картины бизнеса."
        },
        {
            "type": "paragraph",
            "text": "В этой статье речь идет о банковских выписках юридических лиц. Выписки физических лиц в банкротстве имеют другую структуру рисков и требуют отдельного подхода: там важнее личные расходы, переводы родственникам, снятие наличных, сделки с имуществом и движение средств по личным счетам."
        },
        {
            "type": "paragraph",
            "text": "Важно: сама по себе аномалия в выписке не означает, что сделка недействительна или незаконна. Это сигнал для проверки. Нужно смотреть период платежа, финансовое состояние должника, экономический смысл операции, документы, связь сторон и добросовестность получателя."
        },
        {
            "type": "h2",
            "text": "1. Платежи контрагентам с недостоверными сведениями в ЕГРЮЛ"
        },
        {
            "type": "paragraph",
            "text": "Один из первых сигналов – крупные или регулярные платежи организациям, по которым в ЕГРЮЛ есть записи о недостоверности сведений."
        },
        {
            "type": "list",
            "items": [
                "недостоверные сведения о руководителе;",
                "недостоверные сведения об участниках;",
                "массовый адрес;",
                "признаки ликвидации;",
                "сведения о банкротстве;",
                "отсутствие понятной деловой активности;",
                "несоответствие масштаба контрагента объему полученных платежей."
            ]
        },
        {
            "type": "paragraph",
            "text": "Если должник перечислял значительные суммы такой организации, это может указывать на расчеты с технической компанией. В отдельных случаях такие контрагенты могут использоваться как компании-однодневки, но в аналитике лучше говорить аккуратнее: контрагент требует дополнительной проверки."
        },
        {
            "type": "h3",
            "text": "Почему это важно"
        },
        {
            "type": "paragraph",
            "text": "Для оспаривания сделок и анализа вывода активов важно понять, был ли у контрагента реальный экономический смысл в операции: мог ли он поставить товар или оказать услугу, были ли у него сотрудники, ресурсы, склад, техника и деловая история, соответствует ли его профиль назначению платежа, не связан ли он с должником или контролирующими лицами."
        },
        {
            "type": "h3",
            "text": "Пример"
        },
        {
            "type": "paragraph",
            "text": "Должник перечисляет 18 млн рублей компании за консультационные услуги. В выписке платеж выглядит формально нейтрально. Но при проверке контрагента видно: недостоверные сведения о руководителе, массовый адрес, численность персонала – 1 человек, выручка по отчетности несопоставима с масштабом операций."
        },
        {
            "type": "paragraph",
            "text": "Это не доказывает вывод активов автоматически, но делает операцию приоритетной для проверки."
        },
        {
            "type": "h3",
            "text": "Как помогает ФинРадар"
        },
        {
            "type": "paragraph",
            "text": "В ФинРадаре можно увидеть не только платежи, но и риск-маркеры по контрагентам. Сервис агрегирует данные по контрагентам и помогает быстро выделить организации, которые требуют особого внимания: с недостоверными сведениями, признаками банкротства, ликвидации, массовым адресом и другими факторами риска."
        },
        {
            "type": "image",
            "image": {
                "src": "/assets/blog/10-minutes/riski-po-kontragentam.webp",
                "alt": "Анализ рисков по контрагентам в ФинРадаре с маркерами недостоверности, банкротства и ликвидации",
                "caption": "ФинРадар помогает быстро выделить контрагентов с риск-маркерами и посмотреть, какие суммы проходили через них в анализируемом периоде."
            }
        },
        {
            "type": "h2",
            "text": "2. Концентрация исходящих платежей на нескольких слабых контрагентах"
        },
        {
            "type": "paragraph",
            "text": "Вторая важная аномалия – когда значительная часть исходящих платежей сосредоточена на нескольких контрагентах, которые сами выглядят слабыми или непрозрачными."
        },
        {
            "type": "list",
            "items": [
                "у контрагентов низкая численность персонала;",
                "нет заметной деловой репутации;",
                "нет понятной специализации под объем операций;",
                "выручка сопоставима с суммами, которые им перечисляет анализируемое общество;",
                "есть риск-маркеры в ЕГРЮЛ;",
                "профиль деятельности плохо соответствует назначению платежей."
            ]
        },
        {
            "type": "h3",
            "text": "Почему это важно"
        },
        {
            "type": "paragraph",
            "text": "Концентрация платежей сама по себе не является нарушением. У компании может быть один крупный поставщик или подрядчик. Но если этот поставщик не выглядит способным исполнить обязательства на десятки миллионов рублей, это требует отдельной проверки."
        },
        {
            "type": "paragraph",
            "text": "Для арбитражного управляющего здесь важны вопросы: почему именно эти контрагенты получали основной поток денег, были ли реальные поставки, работы или услуги, соответствуют ли платежи рыночным условиям, не использовался ли контрагент как промежуточное звено и не выводилась ли через него маржа или ликвидность должника."
        },
        {
            "type": "h3",
            "text": "Пример"
        },
        {
            "type": "paragraph",
            "text": "За год должник перечислил 72 млн рублей трем компаниям. У каждой – минимальная численность персонала, нет заметной публичной деловой истории, а годовая выручка одной из компаний почти полностью совпадает с суммой, полученной от должника."
        },
        {
            "type": "paragraph",
            "text": "Такая картина может означать, что должник был ключевым или почти единственным источником оборота для контрагента. Это не делает сделки недействительными автоматически, но требует проверки экономического смысла и реальности исполнения."
        },
        {
            "type": "h3",
            "text": "Как помогает ФинРадар"
        },
        {
            "type": "paragraph",
            "text": "В разделе оборотов по контрагентам можно увидеть, кому перечислялись основные суммы, какую долю в исходящем потоке занимает каждый контрагент, сколько операций прошло по контрагенту, как соотносятся платежи, поступления, оборот и нетто-позиция, а также какие контрагенты требуют дополнительной проверки по внешним данным."
        },
        {
            "type": "paragraph",
            "text": "В ФинРадаре можно одним кликом перейти от взаиморасчетов с контрагентом к его проверке по данным ЕГРЮЛ с учетом финансовой отчетности, налогов, численности персонала и других сведений."
        },
        {
            "type": "image",
            "image": {
                "src": '/assets/blog/first-check/oboroty-po-kontragentam.webp',
                "alt": "Обороты по контрагентам в банковской выписке должника и концентрация исходящих платежей",
                "caption": "Обороты по контрагентам показывают концентрацию исходящих платежей и долю каждого участника в денежном потоке."
            }
        },
        {
            "type": "h2",
            "text": "3. Активные встречные расчеты с одним контрагентом"
        },
        {
            "type": "paragraph",
            "text": "Иногда аномалия видна не в отдельном платеже, а в характере расчетов с одним и тем же контрагентом. Например, должник регулярно перечисляет деньги контрагенту за сырье, материалы или услуги, а затем получает от него поступления за готовую продукцию, товары или работы. Другой случай, когда в одну сторону идут деньги за товары, а обратно - в виде займов."
        },
        {
            "type": "paragraph",
            "text": "Формально такие операции могут выглядеть как обычные хозяйственные отношения: одна сторона поставляет сырье, другая покупает продукцию. Но для арбитражного управляющего это важный сигнал: если контрагент одновременно является и поставщиком, и покупателем, нужно проверить экономический смысл такой модели и фактическое распределение выгоды."
        },
        {
            "type": "h3",
            "text": "Почему это важно"
        },
        {
            "type": "paragraph",
            "text": "Встречные расчеты с одним контрагентом могут быть нормальной частью бизнеса. Но они требуют внимания, если через такого контрагента проходит существенная доля оборота, операции повторяются регулярно, а маржа или экономический результат выглядят неочевидно."
        },
        {
            "type": "list",
            "items": [
                "почему один и тот же контрагент одновременно продает сырье и покупает продукцию;",
                "соответствуют ли цены рыночным условиям;",
                "где остается экономическая выгода;",
                "не формируется ли убыток у должника при прибыли у другой стороны;",
                "есть ли связь контрагента с должником, руководством или участниками;",
                "подтверждены ли поставки, отгрузки и встречное исполнение;",
                "не используется ли контрагент как промежуточное звено для перераспределения прибыли."
            ]
        },
        {
            "type": "h3",
            "text": "Пример"
        },
        {
            "type": "paragraph",
            "text": "Должник регулярно платит одному и тому же контрагенту за ткани и фурнитуру. В то же время от этого же контрагента поступают деньги за готовую одежду. В выписке это выглядит как встречный поток: должник то платит контрагенту, то получает от него поступления."
        },
        {
            "type": "paragraph",
            "text": "На первом уровне это может быть обычная хозяйственная модель. Но если по итогам периода должник несет основную производственную нагрузку, оплачивает сырье, персонал и операционные расходы, а прибыль фактически остается у контрагента, такая структура требует проверки."
        },
        {
            "type": "paragraph",
            "text": "Управляющему стоит сопоставить платежи за сырье, поступления за продукцию, договоры, товарные документы, цены, маржинальность и связь сторон. Особенно важно понять, не приводила ли такая модель к тому, что обязательства и расходы оставались на должнике, а экономическая выгода концентрировалась у другого лица."
        },
        {
            "type": "h3",
            "text": "Как помогает ФинРадар"
        },
        {
            "type": "paragraph",
            "text": "ФинРадар помогает быстро увидеть встречные обороты с конкретным контрагентом: сколько должник перечислил ему, сколько получил обратно, в какие периоды проходили расчеты и какие типы операций использовались."
        },
        {
            "type": "paragraph",
            "text": "В отчете по контрагенту можно отдельно посмотреть поступления, платежи, нетто-позицию, динамику по периодам, назначения платежей и варианты наименований из выписок. Это делает кейс удобным для первичной проверки: управляющий сразу видит, что контрагент работает с должником в обе стороны, а затем может перейти к документам и экономическому смыслу операций."
        },
        {
            "type": "image",
            "image": {
                "src": "/assets/blog/7-anomaliy/otchet-po-kontragentu-vstrechnye-raschety.webp",
                "alt": "Отчет по контрагенту в ФинРадаре с встречными расчетами, поступлениями и платежами",
                "caption": "Отчет по контрагенту помогает увидеть встречные обороты: сколько должник перечислил контрагенту, сколько получил от него обратно и как менялась нетто-позиция по периодам."
            }
        },
        {
            "type": "h2",
            "text": "4. Погашение займов физическим лицам незадолго до банкротства"
        },
        {
            "type": "paragraph",
            "text": "Отдельного внимания заслуживают платежи физическим лицам с назначением вроде: возврат займа, погашение займа, возврат денежных средств по договору займа или расчеты по договору займа."
        },
        {
            "type": "paragraph",
            "text": "Особенно если такие платежи проходят за месяц или несколько месяцев до подачи заявления о банкротстве."
        },
        {
            "type": "h3",
            "text": "Почему это важно"
        },
        {
            "type": "paragraph",
            "text": "Погашение займа само по себе законно. Но в предбанкротный период такие операции требуют проверки, особенно если получатель связан с должником, руководителем, участниками или менеджментом."
        },
        {
            "type": "list",
            "items": [
                "когда возникло обязательство по займу;",
                "действительно ли деньги ранее поступали должнику;",
                "кто является получателем;",
                "есть ли связь с контролирующими лицами;",
                "было ли у должника уже ухудшение финансового состояния;",
                "не получил ли один кредитор преимущество перед другими."
            ]
        },
        {
            "type": "h3",
            "text": "Пример"
        },
        {
            "type": "paragraph",
            "text": "За месяц до подачи заявления о банкротстве должник перечисляет физическому лицу 9,5 млн рублей как возврат займа. При этом на тот же период уже есть просроченные обязательства перед поставщиками, налоговой или банком."
        },
        {
            "type": "paragraph",
            "text": "Такая операция может быть значимой для анализа предпочтительного удовлетворения требований, вывода ликвидности или расчетов со связанным лицом."
        },
        {
            "type": "h3",
            "text": "Как помогает ФинРадар"
        },
        {
            "type": "paragraph",
            "text": "Самый быстрый способ найти расчеты по займам в период перед банкротством - развернуть операции по такому типу расчетов за нужный период."
        },
        {
            "type": "paragraph",
            "text": "В ФинРадаре можно также использовать фильтры по типу операции, фильтр по физическим лицам, фильтр по периоду перед банкротством, поиск по назначению платежа и реестр платежей с детализацией суммы, даты, контрагента и назначения."
        },
        {
            "type": "image",
            "image": {
                "src": "/assets/blog/first-check/filtry-reestra-platezhey.webp",
                "alt": "Фильтры реестра платежей для поиска займов, подотчетных сумм и подозрительных операций",
                "caption": "Фильтры помогают быстро найти займы, подотчетные суммы и другие операции по типу, периоду и назначению."
            }
        },
        {
            "type": "h2",
            "text": "5. Резкий рост выплат заработной платы руководителю и топ-менеджерам"
        },
        {
            "type": "paragraph",
            "text": "Зарплата – обычная хозяйственная операция. Но резкий рост выплат в предбанкротный период может быть важной аномалией."
        },
        {
            "type": "list",
            "items": [
                "выплаты увеличиваются незадолго до банкротства;",
                "получатели – учредитель-директор или топ-менеджеры;",
                "суммы достигают миллионов рублей в месяц;",
                "нет сопоставимого роста налогов и страховых взносов;",
                "выплаты происходят на фоне ухудшения финансового состояния компании."
            ]
        },
        {
            "type": "h3",
            "text": "Почему это важно"
        },
        {
            "type": "paragraph",
            "text": "Если компания за несколько месяцев до банкротства резко увеличивает выплаты связанным сотрудникам, это может указывать на вывод ликвидности под видом зарплаты, премий или компенсаций."
        },
        {
            "type": "paragraph",
            "text": "Нужно проверять трудовые договоры, приказы о премировании, экономическое обоснование выплат, должности и функции получателей, НДФЛ и страховые взносы за эти периоды, финансовое состояние компании на дату выплат и сопоставимость выплат с обычным уровнем дохода."
        },
        {
            "type": "h3",
            "text": "Пример 1"
        },
        {
            "type": "paragraph",
            "text": "За 3 месяца до банкротства зарплатные выплаты выросли с 400 тыс. до 4,8 млн рублей в месяц. Основные получатели – директор, учредитель и несколько топ-менеджеров."
        },
        {
            "type": "paragraph",
            "text": "Сам рост выплат не доказывает нарушение, но требует проверки: почему выплаты выросли именно в этот период, были ли основания для премий, удерживался ли НДФЛ, начислялись ли страховые взносы, соответствовали ли выплаты реальной работе."
        },
        {
            "type": "h3",
            "text": "Пример 2"
        },
        {
            "type": "paragraph",
            "text": "За несколько месяцев до банкротства должник начал перечислять почти все свободные средства нескольким сотрудникам под видом заработной платы. При этом НДФЛ и страховые взносы за те же периоды оставались примерно на прежнем уровне."
        },
        {
            "type": "paragraph",
            "text": "В отдельные месяцы выплаты директору подскакивали до 6–7 млн рублей, в другие – достигали 2–3 млн рублей. Такая динамика требует отдельного анализа, потому что может указывать на несоответствие между фактическими выплатами и налоговой частью зарплатного контура."
        },
        {
            "type": "h3",
            "text": "Как помогает ФинРадар"
        },
        {
            "type": "paragraph",
            "text": "ФинРадар помогает увидеть динамику зарплатных выплат, рост выплат по месяцам, операции по конкретным получателям, типы операций, связанные с зарплатой и аналогичными платежами, периоды резкого роста и платежи в пользу руководителей или сотрудников, если они выделены в реестре."
        },
        {
            "type": "image",
            "image": {
                "src": "/assets/blog/7-anomaliy/zarplatnye-anomalii.webp",
                "alt": "Обороты по типам операций в ФинРадаре для поиска резкого роста зарплат и других выплат",
                "caption": "Динамика по типам операций помогает увидеть резкий рост отдельных категорий платежей, например выплат физическим лицам или зарплатных перечислений."
            }
        },
        {
            "type": "h2",
            "text": "6. Регулярные выдачи подотчетных средств крупными суммами"
        },
        {
            "type": "paragraph",
            "text": "Подотчетные средства – нормальный инструмент хозяйственной деятельности. Но если выплаты под отчет становятся регулярными, крупными и плохо объяснимыми, это отдельный риск."
        },
        {
            "type": "list",
            "items": [
                "выдачи по 2–3 млн рублей каждый месяц;",
                "несколько получателей из числа руководства или сотрудников;",
                "повторяющиеся назначения платежей;",
                "отсутствие очевидной связи с хозяйственной деятельностью;",
                "отсутствие понятного закрытия авансовыми отчетами;",
                "выплаты на фоне ухудшения финансового состояния."
            ]
        },
        {
            "type": "h3",
            "text": "Почему это важно"
        },
        {
            "type": "paragraph",
            "text": "Крупные подотчетные суммы могут быть каналом вывода денежных средств, если по ним нет подтвержденных расходов, авансовых отчетов и экономического смысла."
        },
        {
            "type": "paragraph",
            "text": "Для проверки нужно смотреть, кому выдавались деньги, на какие цели, есть ли авансовые отчеты, какие первичные документы подтверждают расходы, возвращались ли неиспользованные суммы, были ли выплаты регулярными и связаны ли получатели с руководством или участниками."
        },
        {
            "type": "h3",
            "text": "Пример"
        },
        {
            "type": "paragraph",
            "text": "Каждый месяц должник перечисляет одному или нескольким сотрудникам по 2–3 млн рублей под отчет. При этом в выписке не видно регулярного возврата неиспользованных сумм, а назначение платежей остается общим: подотчет, хозяйственные расходы, на нужды организации."
        },
        {
            "type": "paragraph",
            "text": "Такая картина требует проверки авансовых отчетов и реальности расходов."
        },
        {
            "type": "h3",
            "text": "Как помогает ФинРадар"
        },
        {
            "type": "paragraph",
            "text": "В ФинРадаре можно отфильтровать операции по типам транзакций, искать платежи по назначениям, смотреть динамику подотчетных выплат, анализировать получателей, выделять повторяющиеся платежи и суммы, а также смотреть периоды, где такие операции резко выросли."
        },
        {
            "type": "image",
            "image": {
                "src": "/assets/blog/7-anomaliy/podotchetnye-summy-anomalii.webp",
                "alt": "ФинРадар показывает, сколько подотчетных средств ушло со счетов организации",
                "caption": "Регулярные перечисления средств под отчет формируют направление для более детальной проверки такой деятельности должника. Есть ли авансовые отчеты, как использовались средства, был ли реальный экономический смысл у таких операций."
            }
        },
        {
            "type": "h2",
            "text": "7. Расходы корпоративной картой на ювелирные магазины, рестораны и поездки"
        },
        {
            "type": "paragraph",
            "text": "Самая наглядная аномалия – расходы, которые плохо похожи на обычные нужды бизнеса."
        },
        {
            "type": "list",
            "items": [
                "покупки в ювелирных магазинах;",
                "рестораны;",
                "туристические поездки;",
                "отели и авиабилеты для руководителя;",
                "дорогостоящие личные расходы;",
                "регулярные расходы по корпоративной карте без понятной деловой цели."
            ]
        },
        {
            "type": "h3",
            "text": "Почему это важно"
        },
        {
            "type": "paragraph",
            "text": "Корпоративная карта может использоваться для законных расходов. Но если деньги компании направляются на личное потребление руководителя или связанных лиц, это требует проверки."
        },
        {
            "type": "paragraph",
            "text": "Особенно в предбанкротный период, когда компания уже испытывала финансовые трудности или имела просроченные обязательства перед кредиторами."
        },
        {
            "type": "paragraph",
            "text": "Нужно выяснить, кто пользовался картой, как расходы связаны с деятельностью общества, есть ли первичные документы, были ли командировки, представительские расходы, договоры, утверждались ли лимиты и компенсировались ли личные расходы компании."
        },
        {
            "type": "h3",
            "text": "Пример"
        },
        {
            "type": "paragraph",
            "text": "В течение нескольких месяцев до банкротства по корпоративной карте проходят регулярные платежи в ресторанах, ювелирных магазинах и туристических сервисах. Назначения платежей и контрагенты не показывают явной связи с деятельностью должника."
        },
        {
            "type": "paragraph",
            "text": "Такие расходы могут стать основанием для дополнительной проверки: были ли они в интересах общества или фактически обслуживали личные потребности контролирующих лиц."
        },
        {
            "type": "h3",
            "text": "Как помогает ФинРадар"
        },
        {
            "type": "paragraph",
            "text": "В ФинРадаре такие операции можно искать через реестр платежей, фильтры по назначению платежа, фильтры по контрагентам, фильтры по типам операций, анализ нетипичных расходов и группировку операций по получателям."
        },
        {
            "type": "h2",
            "text": "Как искать такие аномалии в ФинРадаре"
        },
        {
            "type": "paragraph",
            "text": "Чтобы не просматривать тысячи строк вручную, проверку можно выстроить поэтапно."
        },
        {
            "type": "h3",
            "text": "1. Загрузить выписки в проект"
        },
        {
            "type": "paragraph",
            "text": "Сначала нужно собрать банковские выписки по анализируемому лицу: Excel, TXT / 1C Client-Bank, PDF или другие доступные форматы."
        },
        {
            "type": "h3",
            "text": "2. Проверить качество данных"
        },
        {
            "type": "paragraph",
            "text": "Перед анализом важно убедиться, что нет наложений периодов, дублей операций, пропущенных интервалов и проблемных файлов."
        },
        {
            "type": "image",
            "image": {
                "src": "/assets/blog/10-minutes/kontrol-kachestva-bankovskih-vypisok.webp",
                "alt": "Контроль качества банковских выписок с проверкой наложений, дублей и проблемных периодов",
                "caption": "Перед анализом важно проверить наложения периодов, дубли и проблемные файлы."
            }
        },
        {
            "type": "h3",
            "text": "3. Посмотреть обороты по типам операций"
        },
        {
            "type": "paragraph",
            "text": "Этот раздел помогает увидеть, какие категории платежей формируют основной поток и где есть резкие всплески: зарплатные выплаты, займы, подотчетные средства, расходы физическим лицам, расчеты с поставщиками, операции с банками, ФССП и налогами."
        },
        {
            "type": "h3",
            "text": "4. Изучить обороты по контрагентам"
        },
        {
            "type": "paragraph",
            "text": "Раздел показывает, кто получил основную часть исходящих платежей, кто формирует поступления и насколько поток сконцентрирован на отдельных участниках."
        },
        {
            "type": "h3",
            "text": "5. Открыть раздел рисков"
        },
        {
            "type": "paragraph",
            "text": "Здесь можно увидеть контрагентов, которые требуют особого внимания: с риск-маркерами из ЕГРЮЛ, признаками банкротства, ликвидации, недостоверности сведений и другими факторами."
        },
        {
            "type": "h3",
            "text": "6. Перейти в отчет по конкретному контрагенту"
        },
        {
            "type": "paragraph",
            "text": "Если контрагент выглядит значимым или рискованным, можно посмотреть его отдельно: суммы, периоды, типы операций, встречные обороты и долю в потоке."
        },
        {
            "type": "h3",
            "text": "7. Использовать реестр платежей и фильтры"
        },
        {
            "type": "paragraph",
            "text": "Фильтры помогают быстро сузить массив операций по периоду, сумме, контрагенту, типу операции, назначению платежа, конкретной выписке и направлению платежа."
        },
        {
            "type": "paragraph",
            "text": "Такой подход помогает перейти от общего массива операций к конкретным платежам, которые нужно проверять глубже."
        },
        {
            "type": "cta",
            "title": "Хотите проверить такие аномалии в своей выписке?",
            "text": "Загрузите банковскую выписку в ФинРадар и посмотрите контрагентов, обороты, риск-маркеры, фильтры и операции, которые требуют внимания."
        },
        {
            "type": "signup"
        },
        {
            "type": "h2",
            "text": "Что важно помнить при анализе аномалий"
        },
        {
            "type": "paragraph",
            "text": "Аномалия – это не готовый вывод. Это повод задать правильные вопросы."
        },
        {
            "type": "list",
            "items": [
                "дату платежа;",
                "период относительно банкротства;",
                "финансовое состояние должника;",
                "связь получателя с должником;",
                "экономический смысл сделки;",
                "договорную базу;",
                "первичные документы;",
                "встречное исполнение;",
                "реальность поставки, работ или услуг;",
                "добросовестность контрагента."
            ]
        },
        {
            "type": "paragraph",
            "text": "ФинРадар помогает быстрее найти и структурировать сигналы, но итоговая правовая оценка всегда требует анализа документов и обстоятельств конкретного дела."
        },
        {
            "type": "h2",
            "text": "Итог"
        },
        {
            "type": "paragraph",
            "text": "В банковской выписке должника-юридического лица можно быстро увидеть операции и контрагентов, которые требуют особого внимания."
        },
        {
            "type": "paragraph",
            "text": "В первую очередь стоит проверить платежи контрагентам с недостоверными сведениями в ЕГРЮЛ, концентрацию исходящих платежей на нескольких слабых контрагентах, встречные расчеты с внешне независимыми участниками, погашение займов физическим лицам незадолго до банкротства, резкий рост выплат руководителю и топ-менеджерам, регулярные выдачи крупных подотчетных сумм и расходы корпоративной картой на личное потребление."
        },
        {
            "type": "paragraph",
            "text": "Такие признаки не доказывают нарушение автоматически, но помогают понять, где может быть скрыт вывод активов, предпочтительное удовлетворение отдельных лиц или экономически необоснованные платежи."
        },
        {
            "type": "cta",
            "title": "Попробуйте ФинРадар бесплатно 7 дней",
            "text": "Загрузите банковскую выписку и посмотрите, какие аномалии, контрагенты, обороты и риск-сигналы можно увидеть в вашем проекте."
        },
        {
            "type": "faq",
            "items": [
                {
                    "question": "Аномалия в банковской выписке юридического лица доказывает нарушение?",
                    "answer": "Нет. Аномалия – это сигнал для проверки. Нужно анализировать документы, период операции, связь сторон, экономический смысл платежа и финансовое состояние должника."
                },
                {
                    "question": "Почему статья отдельно говорит о юридических лицах?",
                    "answer": "У юридических лиц и физических лиц разные структуры рисков. Для юрлиц важны контрагенты, хозяйственные операции, займы, зарплатные выплаты, подотчетные суммы и движение денег между организациями. Выписки физических лиц требуют отдельной методики."
                },
                {
                    "question": "Какие контрагенты требуют внимания в первую очередь?",
                    "answer": "В первую очередь стоит смотреть контрагентов с недостоверными сведениями в ЕГРЮЛ, признаками ликвидации или банкротства, низкой численностью, сомнительной деловой репутацией и высокой долей в исходящих платежах должника."
                },
                {
                    "question": "Почему резкий рост зарплат перед банкротством может быть аномалией?",
                    "answer": "Зарплата сама по себе является обычной хозяйственной операцией. Но если выплаты руководителю, учредителю или топ-менеджерам резко растут незадолго до банкротства, особенно без сопоставимого роста НДФЛ и страховых взносов, это требует дополнительной проверки."
                },
                {
                    "question": "Как ФинРадар помогает искать такие операции?",
                    "answer": "ФинРадар помогает загрузить выписки, проверить качество данных, увидеть обороты по типам операций и контрагентам, открыть риск-маркеры, перейти в отчет по контрагенту и отфильтровать платежи по периоду, сумме, назначению и типу операции."
                }
            ]
        }
    ]
};

export default post;
